import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { TableComponent } from 'app/shared/table/table.component';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LetterCodeListVm } from '../../shared/generated/Clients/Models/LetterCodeListVm';
import { EditLetterCodeVm } from '../../shared/generated/Clients/Models/EditLetterCodeVm';
import { SystemMessage } from 'app/core/system-message/system-message-service';

@Component({
    selector: 'pcg-lettercode-list',
    imports: [SharedModule, RouterModule],
    templateUrl: './lettercode-list.component.html',
    styleUrls: ['./lettercode-list.component.css']
})
export class LettercodeListComponent {
	@Input() letterCodeId: number | null = null;
	@ViewChild(TableComponent, { static: false }) table: TableComponent<LetterCodeListVm>;
	@ViewChild('createLetterCode', { static: true }) modalContent: TemplateRef<any>;

	columns = LetterCodeListVm.ColumnDefs;
	dataSource = 'api/Clients/Client/GetLetterCodeList/';
	deleteUrl = `api/Clients/Client/DeleteLetterCode`;

	letterCodeFormGroup = EditLetterCodeVm.Form;
	letterCodeModel = EditLetterCodeVm.GetModel(this.letterCodeFormGroup);

	constructor(public title: Title, public router: Router, public modalService: NgbModal) {}

	ngOnInit() {
		if (this.letterCodeId != null) {
			this.dataSource += this.letterCodeId;
			this.deleteUrl = `api/Clients/Client/DeleteLetterCode`;
			return;
		}

		this.title.setTitle('Letter Code List');
	}

	async reloadTable() {
		this.table.ajaxData;
		this.table.ajaxReload();
	}

	redirectClient(row) {
		this.router.navigateByUrl(`clients/edit-client/${row.clientId}`);
	}
	openModal(id = 0, name = '') {
		this.modalService.open(this.modalContent, {});
		this.letterCodeFormGroup.get('letterCodeName')?.setValue(name);
		this.letterCodeFormGroup.get('letterCodeId')?.setValue(id);
	}
}
